export const TREE = 'environmentData'
export const BRANCH = 'environment'
